import axios from '@/axios'
import utils from '@/api/utils.js'

// Auth
export function checkLogin () {
  console.log('Checking login status...')
  if (!localStorage.getItem('currentUser')) {
    return false
  }
  return true
}

export function setError (data) {
  localStorage.setItem('Error', data)
}

export function getError () {
  if (utils.size(localStorage.getItem('Error')) > 0) {
    return false
  }
}

export async function logintoken (data) {
  try {
    const res = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/auth/sanctum/token', data)
    // console.log(res)
    axios.defaults.headers.common.Authorization = `Bearer ${res.data.data.token}`
    localStorage.setItem('token', res.data.data.token)
    await this.me()
  } catch (e) {
    console.log(e)
    return false
  }
}

export async function me () {
  try {
    const response = await axios.get(import.meta.env.VITE_API_URL + '/v1/intranet/auth/me')
    // localStorage.clear()
    utils.setUser(response.data.data)
    utils.setPermissions(response.data.data.intranet_permissions)
  } catch {
    localStorage.clear()
    this.setError('Não foi possível obter os dados do usuário')
    return false
  }
}

export async function logout () {
  try {
    await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/auth/sanctum/token-logout')
  } catch {
    // console.log('erro ao deslogar')
  }
  localStorage.clear()
}

export async function getPermissions () {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v1/intranet/intranet-permissions')
  return response.data.data
}

export default {
  checkLogin,
  setError,
  getError,
  me,
  logintoken,
  logout,
  getPermissions
}
